/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ramesh Prajapati - ramesh.prajapati@bacancytechnology.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RestResponse } from '../model';
import { SearchableProvider } from '../model/interface/searchable.provider';
import { ApiHeaders } from './headers';
import { Tag } from '../model/tag';
import { CannedResponse } from '../modules/manage/model/canned-response/canned-response';

@Injectable()
export class CannedResponseProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) { }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    // in id we are passing selected tags
    return this.getCannedResponses(page ? page : 1, query);
  }

  getCannedResponses(page: number, query?: string, type?: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/canned-response/list?page=${page}` +
        (query ? '&query=' + encodeURIComponent(query) : '') +
        (type ? '&type=' + encodeURIComponent(type) : ''),
        ApiHeaders.getOptions());
  }

  getCannedResponseById(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/canned-response/${id}`, ApiHeaders.getOptions());
  }

  delete(cannedResponse: CannedResponse): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/canned-response/${cannedResponse.ID}`, ApiHeaders.getOptions());
  }

  create(cannedRespnse: CannedResponse): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/canned-response`, cannedRespnse, ApiHeaders.getOptions());
  }

  saveCannedResponse(cannnedResponse: CannedResponse): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/canned-response`, cannnedResponse, ApiHeaders.getOptions());
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return null;
  }

  getSearchType(): string {
    return 'CANNED_RESPONSE';
  }
}
